<template>
  
     <nav class="quaternary-bg">
		<slot></slot>

		<ul class="navigation-menu">
			<li class="navigation-menu-item pb-2"
				v-for="menuItem in NAVIGATION_MENU_CONFIGS"
				v-bind:key="menuItem.label">

				<div v-if="hasVisibilityPermission(menuItem)" class="navigation-menu-item-container">
					<v-icon>{{ menuItem.icon }}</v-icon>
					<a v-if="menuItem.type == 'icontext'" :href="menuItem.href">{{ menuItem.label }}</a>
				</div>
			</li>

			<!-- Sub Menu: voce di menù e items del menu sistema -->
			<li class="navigation-menu-item pb-2"
				:class="{'menu-icon-colored': openMenu}">
				<v-menu
					class="navigation-menu-submenu"
					z-index="10"
					v-model="openMenu"
					transition="slide-x-reverse-transition"
					absolute
					:position-y="SUBMENU_POSITION_Y"
					:position-x="SUBMENU_POSITION_X">
					<template v-slot:activator="{ on, attrs }">

						<div class="item-menu-container navigation-menu-item-container">
							<v-icon :class="{'rotate-90': openMenu}">{{ NAVIGATION_SUB_MENU_CONFIGS.icon }}</v-icon>
							<span
								v-bind="attrs"
								v-on="on">
								{{ NAVIGATION_SUB_MENU_CONFIGS.label }}
							</span>
						</div>
					</template>
					
					<v-list
						class="header-menu-list">
						<template 
							v-for="menuItem in NAVIGATION_SUB_MENU_CONFIGS.children">

							<div v-if="hasVisibilityPermission(menuItem)"
								v-bind:key="menuItem.label"
								class="header-menu-item">
								<v-list-item class="pa-1">
									<v-icon class="mr-1">{{ menuItem.icon }}</v-icon>
									<a :href="menuItem.href">{{ menuItem.label }}</a>
								</v-list-item>

								<!--
								<v-divider
									v-if="index < NAVIGATION_SUB_MENU_CONFIGS.children.length - 1"
									:key="index">
								</v-divider>
								-->

							</div>
						</template>
					</v-list>

				</v-menu>
			</li>

			<!-- Sezione Login/Logout - Utente -->
			<li class="navigation-menu-item pb-2" v-if="prop_user == null">
				<div class="item-menu-container navigation-menu-item-container ">
					<v-icon>{{ NAVIGATION_MENU_AUTH_CONFIGS.login.icon }}</v-icon>
					<a :href="NAVIGATION_MENU_AUTH_CONFIGS.login.href">{{ NAVIGATION_MENU_AUTH_CONFIGS.login.label }}</a>
				</div>
         </li>

			<li class="navigation-menu-item no-hover-color pb-2" v-if="prop_user != null">
				<div class="item-menu-container navigation-menu-item-container">
					<v-icon>mdi-account</v-icon>
					<a href="/sigma/authentication/profile">{{ prop_user.username }}</a>
				</div>
         </li>

			<li class="navigation-menu-item pb-2"
				v-if="prop_user != null">
				
				<div class="item-menu-container navigation-menu-item-container">
					<v-icon>{{ NAVIGATION_MENU_AUTH_CONFIGS.logout.icon }}</v-icon>
					<a :href="NAVIGATION_MENU_AUTH_CONFIGS.logout.href">{{ NAVIGATION_MENU_AUTH_CONFIGS.logout.label }}</a>
				</div>
         </li>
		</ul>
	</nav>

</template>

<style scoped>
    nav {
		position: absolute;
		right: 20px;
		bottom: 0;
	}
	.navigation-menu {
		list-style-type: none;
		display: flex;
  		justify-content: space-between;
		align-items: center;
	}

	ul.navigation-menu li.navigation-menu-item.menu-icon-colored a,
	ul.navigation-menu li.navigation-menu-item.menu-icon-colored i,
	ul.navigation-menu li.navigation-menu-item.menu-icon-colored span,
	ul.navigation-menu li.navigation-menu-item.menu-icon-colored:hover a,
	ul.navigation-menu li.navigation-menu-item.menu-icon-colored:hover i 
	ul.navigation-menu li.navigation-menu-item.menu-icon-colored:hover span 
	{
		color: #ffffff !important;
	}
	
	ul.navigation-menu li.navigation-menu-item {
		padding: 0 10px 10px 10px;
		font-size: 15px;
	}
	ul.navigation-menu li.navigation-menu-item:hover * {
		color: var(--v-hoverOnMenuColor-base) !important;
	}

	ul.navigation-menu li.navigation-menu-item .navigation-menu-item-container {
		display: flex;
		align-items: center;
	}

	ul.navigation-menu li.navigation-menu-item a {
		padding: 0 3px 0 3px;
		text-decoration: none;
	}

	ul.navigation-menu li.navigation-menu-item .v-icon {
		font-size: 19px;
	}
	
	.header-menu-list a {
		text-decoration: none;
	}

	.header-menu-item {
		font-size: 15px;
		border-bottom: 1px solid #dedede;
		margin: 0 7px 0 4px;
		line-height: 30px;
	}
	
	/*
	.header-menu-item a {
		font-size: 1.124em;
		color: #2f2f2f;
	}
	.header-menu-item i {
		color: #2f2f2f;
	}
	*/

	.v-menu__content {
		left: auto !important;
		right: 0 ! important;
	}

	/*
	Specifici per SIGMA
	*/
	.v-application .header-menu-list a {
		color: #222222 !important;
	}

</style>

<script>
import { NAVIGATION_MENU_CONFIGS, NAVIGATION_SUB_MENU_CONFIGS, NAVIGATION_MENU_AUTH_CONFIGS } from './NavigationMenuConfigs.js';
const { Utils } = require('@/assets/js/scripts/utils/Utils.js');

export default {
   name: "NavigationMenu",
	props: [
		'prop_user',
	],

   data() {
      return {
			openMenu: false,

			SUBMENU_POSITION_Y: 93,
			SUBMENU_POSITION_X: 0,

			NAVIGATION_MENU_CONFIGS: NAVIGATION_MENU_CONFIGS,
			NAVIGATION_SUB_MENU_CONFIGS: NAVIGATION_SUB_MENU_CONFIGS,
			NAVIGATION_MENU_AUTH_CONFIGS: NAVIGATION_MENU_AUTH_CONFIGS,		
      }
   },

    methods: {

		hasVisibilityPermission(item) {
			if (Utils.isNullOrUndefined(item)) {
				return false;
			}

			let requiresPermission = !Utils.isNullOrUndefined(item.codePermission);

			if (requiresPermission) {
				if (Utils.isNullOrUndefined(this.prop_user) || Utils.isNullOrUndefined(this.prop_user.permissions)) {
					//Le prop sono undefined
					return false;
				}

				let visible = Utils.isTrueLoose(this.prop_user.permissions[item.codePermission]);
				return visible;

			} else {
				//non profilato
				return true;
			}
		}

    }
}
</script>
